/**
 * Copyright 2020 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import cx from 'classnames';
import type { ContentStackRichTextEditor } from '../../interface/content-types';
import styles from './CMSRichText.module.scss';
import { Text, View, classNames } from '@az/starc-ui';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { CMSHeadline } from '../CMSHeadline/CMSHeadline';
import { useCMSRichTextModal } from '../../hooks/useCMSRichTextModal';
type Props = {
  content: ContentStackRichTextEditor & {
    textAlignment?: 'Left' | 'Center';
  };
  fullWidth?: boolean;
};

export const CMSRichText = ({ content, fullWidth = false }: Props) => {
  const { query } = useLegacyRouter();
  const isMXorBRCircularPage = query.pageName === 'folleto' || query.pageName === 'folheto';
  const description_background = content.description_background ?? 'None';

  const sectionClassName = classNames(
    description_background.match(/Padding/) && styles.padding,
    description_background.match(/Background[ ]?Color/) && styles.background,
    isMXorBRCircularPage && styles.circularPage,
  );

  const headlineClassName = cx(styles.headline, {
    [styles.headlineMedium]: content.heading_font === 'Medium',
    [styles.headlineHeavy]: content.heading_font === 'Heavy',
    [styles.headlineCenterAligned]: content.heading_alignment === 'Center',
  });
  const { processedHTML, handleClick, ModalComponents } = useCMSRichTextModal(content.description);

  return (
    <View as="section" className={sectionClassName}>
      <CMSHeadline noGutter className={headlineClassName} underline={content.heading_underline}>
        {content.headline}
      </CMSHeadline>
      <Text
        className={cx(styles.richText, {
          [styles.centerAligned]: content.alignment === 'Center',
          [styles.textCenterAligned]: content.textAlignment === 'Center',
          [styles.fullWidth]: fullWidth || isMXorBRCircularPage,
        })}
        attributes={{
          dangerouslySetInnerHTML: { __html: processedHTML },
          onClick: handleClick,
        }}
      >
        {null}
      </Text>
      <ModalComponents />
    </View>
  );
};
